/// <reference path="../../node_modules/@types/jquery/index.d.ts" />

namespace Seac.Components {
	export class TopMenu {
		public leftMenuToggleButtonId			: string;
		public leftMenuPreferitiToggleButtonId	: string;
		public tutorialViewButtonId				: string

		private _leftMenuToggleButtonInstance			: JQuery<HTMLElement>;
		private _leftMenuPreferitiToggleButtonInstance	: JQuery<HTMLElement>;
		private _tutorialViewButtonInstance				: JQuery<HTMLElement>;

		get leftMenuIsOpen(): boolean {
			return Seac.Components.leftMenuComponent.isOpened();
		}
		set leftMenuIsOpen(open: boolean) {
			if (open) {
				Seac.Components.leftMenuComponent.showMenu();
			}else {
				Seac.Components.leftMenuComponent.hideMenu();
			}
		}

		public init(): void {
			this._leftMenuToggleButtonInstance			= $(`#${this.leftMenuToggleButtonId}`);
			this._leftMenuPreferitiToggleButtonInstance	= $(`#${this.leftMenuPreferitiToggleButtonId}`);
			this._tutorialViewButtonInstance			= $(`#${this.tutorialViewButtonId}`);

			/** Evento click sul pulsante di visualizza/nascondi del menu laterale */
			this._leftMenuToggleButtonInstance.click((event: JQuery.ClickEvent) => {
				Seac.Components.leftMenuComponent.toggleMenu();
			});

			/** Evento click sul pulsante di visualizza/nascondi della gestione dei preferiti */
			this._leftMenuPreferitiToggleButtonInstance.click((event: JQuery.ClickEvent) => {
				Seac.Components.leftMenuComponent.toggleGestionePreferiti();
			});

			/** Evento click sul pulsante di visualizzazione del tutorial */
			this._tutorialViewButtonInstance.click((event: JQuery.ClickEvent) => {
				Seac.Components.tutorialViewer.toggleTutorial();
			});
		}
	}

	export let topMenuComponent: TopMenu = new Seac.Components.TopMenu(); 
	jQuery(document).ready(function() {
		topMenuComponent.init();
	});
}
